export default {
    setUserInformation:(state,user)=>state.user=user
}